import React, { createContext, useContext, useEffect, useState } from 'react';
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import Cookies from "js-cookie";
import UserPool from "../services/UserPool";
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession } from 'aws-amplify/auth';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);


export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    jwt: null,
    organizationId: null,
    organizationName: null,
    isAuthenticated: false,
    isLoading: true,
    userId: null,
    permissions: {}, // Add permissions property here
  });

  useEffect(() => {
    console.log(authState);
  }, [authState]);

  useEffect(() => {
    Hub.listen("auth", ({ payload: { event, data } }) => {
      if (["signedIn", "signedOut", "tokenRefresh"].includes(event)) {
        checkCurrentUser();
      }
    });

    checkCurrentUser();
  }, []);

  const checkCurrentUser = async () => {
    try {
      const session = await fetchAuthSession();
      console.log(session);
      if (!session.userSub) {
        setAuthState({
          jwt: null,
          organizationId: null,
          isAuthenticated: false,
          isLoading: false,
          permissions: {},
        });
        Cookies.remove("accessToken", { domain: ".10k.science" });
        return;
      }
      const idToken = session.tokens.idToken;
      const accessToken = session.tokens.accessToken;

      // Read custom claims from idToken or accessToken.
      const jwt = accessToken.toString();
      const organizationId = idToken.payload["custom:organizationId"];
      const organizationName = idToken.payload["custom:organizationName"];
      const userId = idToken.payload.sub;

      // Extract permissions from the access token payload.
      const permissions = accessToken.payload.permissions || {};

      Cookies.set("accessToken", jwt, {
        domain: ".10k.science",
        secure: true,
        sameSite: "Lax",
        expires: 1,
      });

      setAuthState({
        jwt,
        organizationId,
        organizationName,
        isAuthenticated: true,
        isLoading: false,
        userId,
        permissions,
      });
    } catch (error) {
      console.log("Error fetching user session:", error);
      setAuthState({
        jwt: null,
        organizationId: null,
        isAuthenticated: false,
        isLoading: false,
        permissions: {},
      });
    }
  };

  return (
    <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
  );
};